import { historyMarketResult } from './historyMarketResult';

export const marketsParser = (ranges) => {
  return historyMarketResult(ranges);
};
